import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection, WorksheetChartSection } from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { not } from 'ramda';
import { useSelector } from 'react-redux';
import externalTestMethods from '../../../ExternalTestMethods';

let PreparationSection = ({ createWorksheetSelector }) => {
  const importedPsdResultsId = useSelector(
    createWorksheetSelector('Preparation.AssociatedParticleSizeDistributionResults.ImportedTest.Id')
  );
  const materialIsNotPeat = useSelector(pipe(createWorksheetSelector('Preparation.MaterialIsPeat'), not));

  return (
    <>
      <ListFieldSection>
        <Field
          input={<Checkbox />}
          label="Material is peat"
          name="Preparation.MaterialIsPeat"
          confirm={({ value }) => value === true}
          confirmText={`This action will set the material classification to PT - Peat and disallow further analysis of the material. Are you sure you want to continue?`}
          confirmTitle="Peat Material Classification"
        />
      </ListFieldSection>
      <WorksheetAssociatedTestSection
        label="Particle Size Distribution Results"
        name="Preparation.AssociatedParticleSizeDistributionResults"
        testType="Sieve Analysis"
        visible={materialIsNotPeat}
        optionsLabels={{
          measured: 'Estimated (>= 90% Fines)',
        }}
        defaultSelection="autoImported"
        associatedTestModel={{
          measured: true,
          autoImported: true,
          imported: {
            onlyThisSample: true,
            importedTestResults: (
              <>
                <ListFieldSection>
                  <Field input={<TextOutput />} label="Gravel (%)" name="Preparation.PsdResults.GravelPercentage" />
                  <Field input={<TextOutput />} label="Sand (%)" name="Preparation.PsdResults.SandPercentage" />
                  <Field input={<TextOutput />} label="Fines (%)" name="Preparation.PsdResults.FinesPercentage" />
                </ListFieldSection>
                <ListFieldSection>
                  <Field input={<TextOutput />} label="Cu" name="Preparation.PsdResults.Cu" />
                  <Field input={<TextOutput />} label="Cc" name="Preparation.PsdResults.Cc" />
                </ListFieldSection>
              </>
            ),
            importModel: {
              Id: importedPsdResultsId,
            },
          },
          external: {
            testMethods: [
              externalTestMethods.psdSieveAnalysis.ASTM_D6913,
              externalTestMethods.psdSieveAnalysis.ASTM_C136,
            ],
            permitOtherTestMethods: true,
            externalTestResults: (
              <ListFieldSection>
                <Field
                  input={<NumericInput />}
                  label="Gravel (%)"
                  name="Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.GravelPercentage"
                />
                <Field
                  input={<NumericInput />}
                  label="Sand (%)"
                  name="Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.SandPercentage"
                />
                <Field
                  input={<NumericInput />}
                  label="Fines (%)"
                  name="Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.FinesPercentage"
                />
                <Field
                  input={<NumericInput />}
                  label="Cu"
                  name="Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.Cu"
                />
                <Field
                  input={<NumericInput />}
                  label="Cc"
                  name="Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.Cc"
                />
              </ListFieldSection>
            ),
          },
        }}
      />
      <NamePrefixModifier namePrefix="psdChart">
        <WorksheetChartSection visible={!!importedPsdResultsId && materialIsNotPeat} wide={true} />
      </NamePrefixModifier>
      <ListFieldSection visible={materialIsNotPeat}>
        <Field
          input={<TextOutput />}
          label="Coarse or Fine-Grained Material"
          name="Preparation.CoarseOrFineGrainedMaterial"
          additionalMessagePaths={[
            'Preparation.PsdResults.GravelPercentage',
            'Preparation.PsdResults.SandPercentage',
            'Preparation.PsdResults.FinesPercentage',
          ]}
        />
      </ListFieldSection>
    </>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
